import "./App.css";
import Sudoku from "./Sudoku";

function App() {
  return <Sudoku />;
}

export default App;
